import { Component, PipeTransform, ChangeDetectionStrategy, input } from '@angular/core';

import { SingleFormControlCvaComponent } from 'shared';
import { ReactiveFormsModule } from '@angular/forms';
import { ApplyProvidedPipePipe } from 'design-system';

@Component({
  selector: 'tngh-checkbox',
  standalone: true,
  imports: [ReactiveFormsModule, ApplyProvidedPipePipe],
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent extends SingleFormControlCvaComponent {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  readonly checkboxLabel = input<any>('');
  readonly pipe = input<PipeTransform | undefined>({ transform: (value) => value });
  readonly variant = input<'admin' | 'tablet'>('admin');
}
